import React from 'react';
import { useInvoiceContext } from '../../../components/InvoiceProvider';
import Grid from '@material-ui/core/Grid';
import AddressSection from '../../../components/AddressSection';
import CalculationsSection from '../../../components/CalculationsSection';
import CostOverviewSection from '../../../components/CostOverviewSection';
import InvoiceFiles from '../InvoiceFiles';
import InvoiceStatusSection from '../../../components/InvoiceStatusSection';
import PaymentsSection from '../../../components/PaymentsSection';
import VendorSection from '../../../components/VendorSection';
import ContactInformation from '@afosto/app-components-react/ContactInformation';
import OrdersSection from '@afosto/app-components-react/OrdersSection';

const InvoiceDetails = () => {
  const {
    calculation,
    invoice,
    contact,
    client,
    isFetchingContact,
    organisation,
    isFetchingOrganisation,
    isFetchingAddress,
    billingAddress,
  } = useInvoiceContext();
  const { email, coc_number: cocNumber, vat_number: vatNumber } = invoice?.customer?.contact ?? {};
  const contactData = contact ? { ...contact, email } : null;
  const organisationData = organisation
    ? { ...organisation, coc_number: cocNumber, vat_number: vatNumber }
    : null;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} lg={8} xl={9}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ContactInformation
              contact={contactData}
              organisation={organisationData}
              isLoading={isFetchingContact || isFetchingOrganisation}
            />
          </Grid>
          <Grid item xs={12}>
            <AddressSection
              billingAddress={billingAddress}
              shippingAddress={null}
              showShippingAddress={false}
              isLoading={isFetchingAddress}
            />
          </Grid>
          <Grid item xs={12}>
            <PaymentsSection
              entity={{ type: 'invoice', id: invoice?.id }}
              amount={invoice?.total}
              client={client}
              description={invoice?.number}
              allowCreateTransaction={invoice?.is_paid === false}
            />
          </Grid>
          <Grid item xs={12}>
            <OrdersSection orderIds={invoice?.order_ids} />
          </Grid>
          <Grid item xs={12}>
            <CalculationsSection
              calculations={calculation ? [calculation] : []}
              showCreate={false}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={4} xl={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <InvoiceStatusSection />
          </Grid>
          <Grid item xs={12}>
            <VendorSection vendor={invoice?.vendor} />
          </Grid>
          <Grid item xs={12}>
            <CostOverviewSection calculation={invoice} isLoading={false} />
          </Grid>
          <Grid item xs={12}>
            <InvoiceFiles />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InvoiceDetails;
